module.exports = __webpack_public_path__ + "static/media/PhoneRing.8a18e72d.gif";